module.exports = __webpack_public_path__ + "1f75eaad5d95f2e9405832e43c541321.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map2.jpg
// module id = 470
// module chunks = 2